import { useRef, React } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as SearchIcon } from '../../../image/Searching.svg';

export default function SearchInput(props) {
	const { value, setValue, placeholder } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

	const inputRef = useRef();

	function handleClick(e) {
	}

	function handleChange(e) {
		setValue(e.target.value);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

	return (
    <Wrapper>
      <IconWrapper>
        <StyledSearchIcon width={18} height={18} lineColor={theme.line} />
      </IconWrapper>
      <Input
        ref={inputRef}
        placeholder={placeholder}
        value={value}
        onClick={handleClick}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </Wrapper>
  )
}

const StyledSearchIcon = styled(SearchIcon)`
  & path {
    fill: ${props => props.lineColor};
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  width: 403px;
  height: 34px;
`;

const IconWrapper = styled.div`
  position: absolute;
  left: 10px;

  display: flex;
  justify-content: center;
  align-items: center;

  pointer-events: none;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 12px;
	line-height: 20px;

  padding: 0 0 0 36px;
  width: calc(100% - 38px);
  height: 34px;

	outline: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
	color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

	::placeholder {
    color: ${props => props.theme.line};
	}

  transition: all 0.3s ease-in-out;
`;